import React from 'react';

const withHover = (Component: React.FunctionComponent<any>) => (props: any) => {
	const [hover, setHover] = React.useState(false);

	return (
		<span onMouseOver={() => setHover(true)} onMouseOut={() => setHover(false)}>
			<Component hover={hover} {...props} />
		</span>
	);
};

export default withHover;
